import { ValueOf } from "@twiliointernal/e2-commons-shared-definitions";

export const ActionButtonTypesEnum = {
  TicketSubmission: "ticketSubmission",
  RequestNotification: "requestNotification",
  CallSupport: "callSupport",
} as const;

export type ActionButtonTypes = ValueOf<typeof ActionButtonTypesEnum>;
